import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: '特徴', href: '#features' },
    { label: 'プラン', href: '#plans' },
    { label: '施工の流れ', href: '#process' },
    { label: '会社概要', href: '#about' },
  ];

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/234a308b2a051457e87aa49e683e124d/0c6c322b376751504e57f65121349d16.jpeg"
            alt="トイレ専門店48 forty-eight"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className={`text-sm font-medium transition-colors duration-200 hover:text-accent cursor-pointer ${
                scrolled ? 'text-navy' : 'text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {/* 電話バナー */}
          <a
            href="tel:0297386660"
            className={`flex items-center gap-2 px-4 py-2.5 rounded-full font-medium text-sm whitespace-nowrap transition-all duration-300 cursor-pointer border ${
              scrolled
                ? 'border-navy/20 text-navy hover:border-accent hover:text-accent'
                : 'border-white/40 text-white hover:border-white hover:bg-white/10'
            }`}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill text-sm"></i>
            </span>
            0297-38-6660
          </a>
          {/* LINE見積もり */}
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
            className="flex items-center gap-2 bg-accent hover:bg-accent-dark text-white px-5 py-2.5 rounded-full font-medium text-sm whitespace-nowrap transition-all duration-300 cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill text-base"></i>
            </span>
            LINE見積もり（無料）
          </a>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-navy' : 'text-white'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="text-navy font-medium py-2 border-b border-gray-50 text-sm cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            {/* 電話バナー */}
            <a
              href="tel:0297386660"
              className="flex items-center gap-2 border border-navy/20 text-navy px-5 py-3 rounded-full font-medium text-sm whitespace-nowrap transition-all duration-300 cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-base"></i>
              </span>
              0297-38-6660
            </a>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
              className="mt-1 flex items-center justify-center gap-2 bg-accent hover:bg-accent-dark text-white px-5 py-3 rounded-full font-medium text-sm whitespace-nowrap transition-all duration-300 cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-line-fill text-base"></i>
              </span>
              LINE見積もり（無料）
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
